import {skipToken} from '@reduxjs/toolkit/query';
import {match} from 'ts-pattern';

import {useSelector} from 'react-redux';
import {useParams} from 'react-router-dom';

import {isNotNil, values} from 'ramda';

import {useGetVehicleQuery} from '@dms/api/sales';
import {PartialVehiclePhotosRoutes} from '@dms/api/shared';
import {vehiclesRoutes} from '@dms/routes';
import {selectAudit, selectInspections} from '@dms/teas';

import {useRequiredParams} from 'shared/web';

export const useBatchButtonLocation = () => {
  const {id: vehicleId} = useRequiredParams();
  const {data: vehicleDetail} = useGetVehicleQuery(isNotNil(vehicleId) ? {vehicleId} : skipToken);
  const inspections = useSelector(selectInspections);
  const auditData = useSelector(selectAudit);

  const params = useParams();

  const location = match(params?.tab)
    .with(vehiclesRoutes.DownloadEventVehiclePhotos, () => PartialVehiclePhotosRoutes.vehicle)
    .with(vehiclesRoutes.DownloadEventInspections, () => PartialVehiclePhotosRoutes.inspections)
    .with(vehiclesRoutes.DownloadEventCondition, () => PartialVehiclePhotosRoutes.condition)
    .otherwise(() => PartialVehiclePhotosRoutes.vehicle);

  const isDisabled = match(location)
    .with(PartialVehiclePhotosRoutes.vehicle, () => vehicleDetail?.photos?.length)
    .with(PartialVehiclePhotosRoutes.inspections, () => inspections?.length || auditData?.id)
    .with(PartialVehiclePhotosRoutes.condition, () => values(auditData?.assets ?? {})?.length)
    .otherwise(() => undefined);

  return [location, !isDisabled] as const;
};
